export default __webpack_public_path__ + "static/media/create_task.42be067a.png";